import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Typography, Button, Box, Card } from "@mui/material";
import { getAdviceCareBlog } from "../services/api/adviceCareApi";


export default function AdviceCareDetails() {
    const [adviceCare, setAdvicecare] = useState(null);
    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        const fetchDetails = async () => {
            try {
                const data = await getAdviceCareBlog();

                // 👉 ID match કરવો
                const selected = data.find((item) => item.id === parseInt(id));

                setAdvicecare(selected);

                console.log("DETAIL DATA:", selected);

            } catch (error) {
                console.error("Error fetching details:", error);
            }
        };

        fetchDetails();
    }, [id]);
    if (!adviceCare) return <h2>Loading...</h2>;


    return (
        <Box sx={{ py: { xs: 6, md: 3 } }}>
            <Container maxWidth="xl" sx={{
                px: { xs: 2, sm: 2, md: 2 },
                py: { xs: 2, sm: 0, md: 0 },

            }} disableGutters>
                <Box sx={{ maxWidth: "1440px", mx: "auto" }}>
                    <Card
                        sx={{
                            borderRadius: "36px",
                            px: { xs: 2, sm: 4, md: 6 },
                            py: { xs: 1, sm: 0, md: 0 },
                            mx: { xs: 1, sm: 2, md: 0 },


                            backgroundColor: "background.light",
                        }}
                    >
                        {/* BACK BUTTON */}
                        <Button onClick={() => navigate(-1)} sx={{ mb: 3, textTransform: "none" }}>
                            ← Back to AdviceCare
                        </Button>

                        {/* TITLE & SHORT DESC */}
                        <Box sx={{ mb: { xs: 4, md: 6 } }}>
                            <Typography
                                sx={{
                                    fontSize: { xs: 28, md: 46 },
                                    fontWeight: 700,
                                    mb: 2,
                                    lineHeight: 1.1,
                                }}
                            >
                                {adviceCare.title}
                            </Typography>
                            <Typography sx={{ color: "text.secondary", fontSize: { xs: 16, md: 18 } }}>
                                {adviceCare.short_description}
                            </Typography>
                        </Box>

                        {/* FULL CONTENT + IMAGE */}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", md: "row" },
                                alignItems: "flex-start",
                                gap: { xs: 4, sm: 6, md: 8 },
                            }}
                        >
                            {/* FULL CONTENT */}
                            <Box
                                sx={{ flex: 1, lineHeight: 1.8 }}
                                dangerouslySetInnerHTML={{ __html: adviceCare.full_description }}
                            />
                            {/* IMAGE */}
                            <Box
                                sx={{
                                    flex: { xs: "none", md: "0 0 50%" },
                                    display: "flex",
                                    justifyContent: { xs: "center", md: "flex-end" },
                                    alignItems: "flex-start",
                                }}
                            >
                                <Box
                                    component="img"
                                    src={adviceCare.image}
                                    alt="adviceCare"
                                    sx={{
                                        width: { xs: "100%", md: "80%" },
                                        maxWidth: 400,
                                        height: "auto",
                                        borderRadius: "24px",
                                        objectFit: "cover",
                                        mb: { xs: 2, md: 3 },
                                    }}
                                />
                            </Box>
                        </Box>
                    </Card>
                </Box>
            </Container>
        </Box>
    );
}